import { $addClass, $appendTo, $prependTo } from 'fxdom/es';
import { rune } from 'rune-ts';
import { initToastContainer } from './initToastContainer.js';
import { ToastConfig } from './toast.config.ts';
import { createToastMsg } from './toast.js';

/**
 * `MarketPlaceS`에서 의존성 오류 터져서 임시로 함수로 추출함
 *
 * @return {Function}
 */
export const createPopToastMsgForMarppleShop = () => {
  const end_klass = ToastConfig.endClass;
  let toast_container_el;
  let position = 'INITIAL-POSITION';

  const popToastMsgForMarppleShop = (input_el, type, opt = {}) => {
    const idx_bottom = window.navigator.userAgent.indexOf('safe_area_bottom');
    const safe_area_bottom =
      idx_bottom > -1
        ? Number((window.navigator.userAgent.substr(idx_bottom).split('@')[1] || '').split(' ')[0])
        : 0;

    if (safe_area_bottom > 0) {
      opt.has_bottom_tab_bar = true;
    }

    if (!toast_container_el || position !== opt?.position) {
      const layout_element =
        document.querySelector('.LayoutView') || document.querySelector('.MarppleShopStudioLayoutView');
      if (!layout_element) return;

      const layout_options = rune.getUnknownView(layout_element).state;

      toast_container_el = initToastContainer({ ...opt, ...layout_options });
      position = opt?.position;
    }
    if (!toast_container_el.parentNode) $appendTo(document.body, toast_container_el);
    const item_el = input_el instanceof HTMLElement ? input_el : createToastMsg(type, input_el);

    $prependTo(toast_container_el, item_el);
    setTimeout(() => {
      $addClass(end_klass, item_el);
    }, 2500);
  };

  return popToastMsgForMarppleShop;
};
